import { render, staticRenderFns } from "./NewAffiliation.vue?vue&type=template&id=0e015d77&scoped=true"
import script from "./NewAffiliation.vue?vue&type=script&lang=js"
export * from "./NewAffiliation.vue?vue&type=script&lang=js"
import style0 from "./NewAffiliation.vue?vue&type=style&index=0&id=0e015d77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e015d77",
  null
  
)

export default component.exports